import 'antd/dist/antd.css';
import '../styles/globals.css';
import '../styles/login.css';
import '../styles/main.css';
import '../styles/dashboard.css';
import NoSSRWrapper from "../components/no-ssr-wrapper";
import { SessionProvider } from "next-auth/react"
import { ThemeProvider } from 'next-themes'
import Head from 'next/head';
import ToggleableDiv from '../components/ToggleableDiv'
import CookieConsentBanner from "../components/CookieConsentBanner";
import JobsLayout from '../components/JobsLayout';
import AdminLayout from '../components/AdminLayout';
import { useRouter } from 'next/router';
import '../components/axiosSetup';
import '../components/fetchPatch';
import setupAjax from '../components/ajaxSetup';
import { useEffect, useRef } from 'react';
import { LoaderProvider } from '../components/LoaderContext';
import GlobalLoader from '../components/GlobalLoader';
import { loader } from '../components/LoaderBridge';
function MyApp({ Component, pageProps: { session, ...pageProps }, }) {
  const router = useRouter();
  const isMounted = useRef(true);
  useEffect(() => {
    setupAjax();
    isMounted.current = true;

    const handleStart = () => {
      if (isMounted.current) loader.start();
    }
    const handleStop = () => {
      if (isMounted.current) loader.stop();
    }

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleStop);
    router.events.on('routeChangeError', handleStop);

    return () => {
      isMounted.current = false;
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleStop);
      router.events.off('routeChangeError', handleStop);
    };
  }, [router]);
  const path = router.pathname;
  let PageWithLayout = (
    <Component {...pageProps} />
  );

  if (path.startsWith('/jobs')) {
    PageWithLayout = (
      <JobsLayout>
        <Component {...pageProps} />
      </JobsLayout>
    );
  } else if (path.startsWith('/admin-center')) {
    PageWithLayout = (
      <AdminLayout>
        <Component {...pageProps} />
      </AdminLayout>
    );
  }
  return (

    <SessionProvider session={session}>
      <ThemeProvider enableSystem={false}>
        <NoSSRWrapper>

          <ToggleableDiv>
            <Head>
              <title>Work With Friends</title>
            </Head>
            <LoaderProvider>
              <GlobalLoader />
              {PageWithLayout}
            </LoaderProvider>
            <CookieConsentBanner />
          </ToggleableDiv>
        </NoSSRWrapper>
      </ThemeProvider>
    </SessionProvider>
  )
}

export default MyApp
